module.exports = __webpack_public_path__ + "img/fuwuhao2@2x.71d6b34c.png";